import styled from "styled-components";

export const SNAPCHAT_IMAGE_SIZE_SPEC = {
  // 16:9 = 640:360
  width: 360,
  height: 640,
  pictureWidth: 360,
  minHeight: 640,
  maxHeight: 640
};

export const companyNameStyle = {
  textAlign: "left",
  fontSize: "12px",
  fontWeight: 500,
  color: "#fff"
};

export const titleStyle = {
  textAlign: "left",
  fontSize: "11px",
  fontWeight: 500,
  color: "#b3b3b3"
};

export const PostEditorSnapchatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${SNAPCHAT_IMAGE_SIZE_SPEC.width}px;
`;

export const SnapchatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${SNAPCHAT_IMAGE_SIZE_SPEC.width}px;
  height: ${SNAPCHAT_IMAGE_SIZE_SPEC.height}px;
  box-shadow: 0px 2px 4px 0px #1516331f;
  background: #9ca2ac;
  border-radius: 4px;
  position: relative;
`;

export const HeaderWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 4;
  padding: 7px 11px;
`;

export const FooterWrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 5px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  z-index: 3;
  svg {
    transform: scale(0.5);
  }
`;

export const LearnMoreAnchor = styled.a`
  background-color: #fff;
  border-radius: 13px;
  color: #2c3037;
  font-size: 11px;
  font-weight: 700;
  height: 27px;
  line-height: 27px;
  padding: 0 16px;
  text-transform: capitalize;
  appearance: none;
  user-select: none;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background-color: #f2f2f2;
  }
`;

export const AdText = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  padding: 7px;
  z-index: 3;
`;
